import { Routes } from '@angular/router';
import { DatosAbiertosComponent } from './home/datos-abiertos.component';
import { DatosTesisComponent } from './tesis/tesis.component';

const routes: Routes = [
    {
      path: '',
      component: DatosAbiertosComponent,
      title: 'Datos abiertos',
    },
    {
      path: 'tesis',
      component: DatosTesisComponent,
      title: 'Datos abiertos Tesis',
    },
  ];
  
  export default routes;